<template>
    <el-menu id="navbar"
             :router="true"
             :default-active="defaultNavIndex">
      <el-menu-item index="/home"><icon name="home" /> Dashboard</el-menu-item>
      <el-menu-item index="/wip"><icon name="tasks" /> WIP</el-menu-item>
      <hr>
      <el-menu-item index="/clients"><icon name="book" /> Clients</el-menu-item>
      <el-menu-item index="/projects"><icon name="desktop" /> Projects</el-menu-item>
      <el-menu-item index="/app-builds"><icon name="mobile" /> App Builds</el-menu-item>
      <el-menu-item index="/users"><icon name="users" /> Users</el-menu-item>
      <el-menu-item v-if="currentUser.access_reports" index="/reports"><icon name="chart-line" /> Reports</el-menu-item>
      <hr>
      <el-menu-item index="/account"><icon name="user-circle" /> My Account</el-menu-item>
      <el-menu-item index="/logout"><icon name="sign-out-alt" /> Logout</el-menu-item>
      <hr>
      <li class="el-menu-item">
        <a href="https://docs.charles.mirk.co" target="_blank">
          <icon name="book" /> Mirk Docs <icon name="external-link-alt" class="external-link" scale="0.7" />
        </a>
      </li>
      <hr>
      <li class="el-menu-item">
        <div class="cache-clear" @click="confirmClearCache"><icon name="redo" scale="0.75" /> Clear Cache</div>
      </li>
      <hr>
    </el-menu>
</template>

<script>
  export default {
    name: 'navbar',
    methods: {
      confirmClearCache () {
        this.$confirm('Are you sure you want to clear the cache?', 'Clear Cache', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          this.$store.dispatch('clearCache')
          setTimeout(function () {
            window.location.reload()
          }, 2000)
        }).catch(() => {
          // Do nothing..
        })
      }
    },
    computed: {
      defaultNavIndex () {
        return this.$router.currentRoute.path.split('/')[1]
      },
      // Vuex Mappings
      currentRouteName () {
        return this.$store.state.currentRouteName
      },
      currentUser () {
        return this.$store.state.users.currentUser
      }
    }
  }
</script>

<style lang="less" rel="stylesheet/less" scoped>
  #navbar {
    height: 100%;
    .fa-icon {
      margin-right: 8px;
    }
    hr {
      margin: 0;
      padding: 0;
      background-color: #e6e6e6;
      height: 1px;
      border: 0;
    }

    .cache-clear {
      font-size: 0.75rem
    }

    .external-link {
      margin-left: 6px;
      margin-top: 2px;
      vertical-align: text-top;
      color: #606266;

    }
  }
</style>
